export default __webpack_public_path__ + "Redirect_Blueberry_Transparent.a43a167dca5976245a66.png";